module.exports = __webpack_public_path__ + "static/media/graduate_students.00fcaf05.svg";